import DynamicFeedIcon from "@material-ui/icons/DynamicFeed";
import DocumentTypeList from "./DocumentTypeList";

export default {
  list: DocumentTypeList,
  icon: DynamicFeedIcon,
};
